import React, { memo } from 'react'
import { Text } from '@chakra-ui/core'
import colors from 'constants/colors'
import LocaleText from 'components/LocaleText'
import { useSelector } from 'react-redux'
import { RootState } from 'constants/interfaces'
import strings from 'constants/strings'
import { formatTimestamp } from 'utils'
import { formatDateRange } from '../utils'

interface ILastUpdateProps {
  lastUpdate: string
}

export const LastUpdate = memo(({ lastUpdate }: ILastUpdateProps) => {
  const { theme } = useSelector((state: RootState) => state.general)

  if (!lastUpdate) {
    return null
  }

  let formattedTime: string | undefined
  if (lastUpdate.includes(' - ')) {
    formattedTime = formatDateRange(lastUpdate, theme?.is_support_us_date_format ?? false)
  } else {
    const hasTime = /\d{2}:\d{2}/.test(lastUpdate)
    const inputFormat = hasTime
      ? strings.DATE_FORMATS.outputs.CREATED_AT_TS_FORMAT
      : strings.DATE_FORMATS.outputs.CREATED_AT_TS_WITHOUT_TIME

    const outputFormat = theme?.is_support_us_date_format
      ? hasTime
        ? strings.DATE_FORMATS.outputs.CREATED_AT_TS_US_FORMAT
        : strings.DATE_FORMATS.outputs.CREATED_AT_TS_WITHOUT_TIME_US
      : hasTime
      ? strings.DATE_FORMATS.outputs.CREATED_AT_TS_FORMAT
      : strings.DATE_FORMATS.outputs.CREATED_AT_TS_WITHOUT_TIME

    formattedTime = formatTimestamp(lastUpdate, outputFormat, inputFormat, false)
  }

  return (
    <Text minW="100px" color={colors.greyDark} fontSize="14px">
      <Text as={'span'} fontFamily='"Asap Condensed", sans-serif'>
        <LocaleText text={'last_update'} />
        :&nbsp;
      </Text>
      <Text as={'span'} fontFamily='"Asap Condensed", sans-serif'>
        {formattedTime}
      </Text>
    </Text>
  )
})
